import { createSlice } from '@reduxjs/toolkit';

import { logout } from 'redux/auth/auth-middleware';
import { fetchRetainerAgreement } from 'redux/retainer-agreement/agreement.middleware';
import type { AgreementSummary } from 'types';

type RetainerAgreementState = {
    file: Blob | null;
    summary: AgreementSummary | null;
    error: string | null;
    isLoading: boolean;
};

const initialState: RetainerAgreementState = {
    file: null,
    summary: null,
    error: null,
    isLoading: false,
};

export const retainerAgreementSlice = createSlice({
    name: 'app/retainer-agreement',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchRetainerAgreement.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchRetainerAgreement.fulfilled, (state, action) => {
                state.file = action.payload.file;
                state.summary = action.payload.summary;
                state.isLoading = false;
            })
            .addCase(fetchRetainerAgreement.rejected, (state, action) => {
                state.error = action.error.message || 'Failed to load agreement';
                state.isLoading = false;
            })
            .addCase(logout.fulfilled, () => initialState);
    },
});

export default retainerAgreementSlice.reducer;
